<template>
    <Bubble>
        <!-- <vue-headful title="Datenschutz - Dachaudenktweiter"/> -->
        <div class="row">
            <div class="col-push"></div>
            <div class="col-3-center">
                <h1>Datenschutzerklärung</h1>
                <h2>Datenschutz</h2>
                <p>Wir nehmen den Schutz Ihrer persöhnlichen Daten sehr ernst. Ihre personenbezogenen Daten werden vertraulich und gemäß der Datenschutz-Grundverordnung (DSGVO) behandelt.</p>
                <h2>Verantwortlich für die Datenverarbeitung</h2>
                <ul class="list-style-none">
                    <li>Große Kreisstadt Dachau</li>
                    <li>Konrad-Adenauer-Straße 2-6</li>
                    <li>D-85221 Dachau</li>
                    <li>Vertretungsberechtigt: Oberbürgermeister Florian Hartmann</li>
                    <li>Telefon: +49 8131 75-0</li>
                    <li>Telefax: +49 8131 75-44299</li>
                    <li>E-Mail: stadt@dachau.de</li>
                </ul>
                <h2>Datenschutzbeauftragter</h2>
                <ul class="list-style-none">
                    <li>Albert Wiesbeck</li>
                    <li>Konrad-Adenauer-Straße 2-6</li>
                    <li>D-85221 Dachau</li>
                    <li>E-Mail: datenschutzbeauftragter@dachau.de</li>
                </ul>
                <h2>Server-Log-Files</h2>
                <p>Der Betreiber dieser Webseite erhebt und speichert Informationen in sogenannten Server-Log Files, die automatisch von Ihrem Browser an uns übermittelt werden. Diese Dateien enthalten:</p>
                <ul>
                    <li>Browsertyp und -version</li>
                    <li>Betriebssystem des Rechners</li>
                    <li>Referrer URL</li>
                    <li>IP-Adresse</li>
                    <li>Hostname des zugreifenden Rechners</li>
                    <li>Datum und Uhrzeit der Serveranfrage</li>
                </ul>
                <p>Rechtsgrundlage für die Datenverarbeitung ist Art. 6 Abs. lit. f der DSGVO, der die Verarbeitung von Daten zur Wahrung des berechtigten Interesses gestattet.</p><p>Es erfolgt keine Zusammenführung dieser Daten mit anderen Datenquellen.</p>
                <h2>Registrierungsdaten</h2>
                <p>Bei der Registrierung unter der Rubrik "Mach Mit!" können Sie sich mit einem frei wählbaren Benutzernamen anmelden. Dieser erscheint in Ihren Kommentaren und ist für alle Besucher der Webseite sichtbar.</p>
                <p>Sie haben auch die Option, Ihre Emailadresse zu hinterlegen. Wenn Sie dort das Häkchen setzen, erklären Sie sich damit einverstanden, dass wir diese über die Dauer der Beteiligungphase speichern und Sie gegebenenfalls bei Rückfragen bezüglich Ihrer Kommentare kontaktieren.</p>
                <p>Die von Ihnen übermittelten Registrierungsdaten werden nicht in einem anderen Zusammenhang von uns genutzt oder an Drittpersonen übermittelt. Nach dem Ende der Beteiligungsphase werden alle Benutzerinformationen gelöscht.</p>
            
                <!-- <p>Die dazu eingegeben Daten werden von uns nur zum Zweck der Beteiligung selbst genutzt und nach Ende der Beteilignung gelöscht.</p> -->
                <h2>Cookies</h2>
                <p>Bei einer rein informellen Nutzung dieser Webseite kommen keine Cookies zum Einsatz. Wenn Sie sich unter "Mach Mit!" anmelden, werden einige Anmeldeinformationen in Form eines Cookies auf ihrem Rechner abgelegt. Diese Informationen sind notwendig, um Ihnen das Login zu ermöglichen und werden nach jedem Abmelden automatisch von Ihrem Computer gelöscht.</p>
                <p>Wenn Sie in Ihrem Browser Cookies deaktiviert haben, können Sie daher nicht an der Beteiligung teilnehmen.</p>
                <h2></h2>
            </div>
        </div>
    </Bubble>
</template>

<script>
export default {
  metaInfo: {
    title: "Datenschutz"
  }
};
</script>


<style scoped lang="scss">
.list-style-none {
  list-style: none;
  margin: 0;
  margin-bottom: 1rem;
  padding: 0;
  li {
    margin: 0.2rem 0;
  }
}
</style>